import { render, staticRenderFns } from "./noticeAndDoc.vue?vue&type=template&id=1747548e&scoped=true"
import script from "./noticeAndDoc.vue?vue&type=script&lang=ts"
export * from "./noticeAndDoc.vue?vue&type=script&lang=ts"
import style0 from "./noticeAndDoc.vue?vue&type=style&index=0&id=1747548e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747548e",
  null
  
)

export default component.exports